<template>
  <div class="container_box">
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="520"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--编辑站点弹窗-->
    <Modal v-model="siteInfoModal" :title="siteTitle" width="550" :transfer="false"
      :mask-closable="false" @on-visible-change="siteInfoChange">
      <Form :model="siteInfoForm" ref="siteInfoForm" :rules="ruleValidate" :disabled="siteInfoType ==='look'"
        :label-width="90" @submit.native.prevent>
        <Row style="width: 95%">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003431')" prop="siteName">
              <Input v-model.trim="siteInfoForm.siteName" :placeholder="$t('key1005060')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005063')" prop="siteDomain">
              <Input v-model.trim="siteInfoForm.siteDomain" :disabled="true" :placeholder="$t('key1005064')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005065')" prop="remark">
              <Input v-model.trim="siteInfoForm.remark" :placeholder="$t('key1005066')"
                type="textarea" :autosize="{minRows: 4, maxRows: 8}">
              </Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="siteInfoModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" v-if="siteInfoType ==='edit'" @click="siteQueryBtn">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'siteManage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        pageNum: 1,
        pageSize: 15
      },
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005057'),
          key: 'siteName',
          align: 'left',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005058'),
          key: 'siteDomain',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005059'),
          key: 'remark',
          minWidth: 220,
          align: 'left',
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remark, 220, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 150,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.getSiteInfoData(params.row, 'look');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsSite_update'),
                    clickFn: () => {
                      v.getSiteInfoData(params.row, 'edit');
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      total: 0,
      siteInfoModal: false,
      siteTitle: '',
      siteInfoForm: {
        siteName: '',
        siteDomain: '',
        remark: ''
      },
      ruleValidate: {
        siteName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005060'), trigger: 'blur'}
        ]
      },
      siteInfoType: 'look',
      ymsSiteId: null
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsSite_queryAllYmsSite')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsSite_queryAllYmsSite, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
            v.$forceUpdate();
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 查看站点信息
    getSiteInfoData(row, type) {
      for (let key in this.siteInfoForm) {
        this.siteInfoForm[key] = row[key];
      }
      this.ymsSiteId = row.ymsSiteId;
      this.siteInfoType = type;
      this.siteTitle = type === 'look' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005061') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005062');
      this.siteInfoModal = true;
    },
    // 保存按钮
    siteQueryBtn() {
      let v = this;
      let {siteDomain, ...obj} = v.siteInfoForm;
      obj.ymsSiteId = v.ymsSiteId;
      v.$refs['siteInfoForm'].validate((valid) => {
        if (valid) {
          v.axios.put(api.put_ymsSite, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.siteInfoModal = false;
              v.pageParamsStatus = true;
            }
          });
        }
      });
    },
    // 监听弹窗
    siteInfoChange(value) {
      let v = this;
      if (!value) {
        v.ymsSiteId = null;
        v.$refs['siteInfoForm'].resetFields();
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {}
};
</script>

<style lang="less">

</style>
